import APICall from "../utils/APICall";

export default class ScheduledServices {
  static listSchedules = async (
    page,
    pageLimit,
    search,
    from,
    to,
    transferStatus,
    transferType
  ) => {
    const params = new URLSearchParams({
      page: page || 1,
      pageLimit: pageLimit || 10,
      ...(search && { search }),
      ...(from && { from }),
      ...(to && { to }),
      ...(transferStatus && transferStatus !== "All" && { transferStatus }),
      ...(transferType && transferType !== "All" && { transferType }),
    });

    return await APICall(
      `/api/Transfer/admin/list-scheduled-transfers?${params.toString()}`,
      "GET"
    );
  };

  static viewSchedule = async (transferId) => {
    return await APICall(
      `/api/Transfer/admin/view-scheduled-transfer/${transferId}`,
      "GET"
    );
  };

  static exportSchedule = async (
    search,
    from,
    to,
    transferStatus,
    transferType
  ) => {
    const params = new URLSearchParams({
      ...(search && { search }),
      ...(from && { from }),
      ...(to && { to }),
      ...(transferStatus && transferStatus !== "All" && { transferStatus }),
      ...(transferType && transferType !== "All" && { transferType }),
    });

    return await APICall(
      `/api/Transfer/admin/export-schedule-transfer?${params.toString()}`,
      "GET"
    );
  };
}
